<template>
  <vs-table
    multiple
    no-data-text="No tienes distribuciones con copia"
    v-model="copiesSelected"
    :data="copies"
    class="table"
  >
    <template slot="thead">
      <vs-th>Distribución</vs-th>
      <vs-th>Lista Distribución</vs-th>
      <vs-th>Extra</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
        <vs-td :data="data[indextr].copySubjectType.label">
          {{tr.copySubjectType.label}}
        </vs-td>
        <vs-td :data="data[indextr].copySubject.label">
          {{tr.copySubject.label}}
          <div v-if="isExternSubjects.includes(tr.copySubjectType.value)">
            <span>
              {{tr.copySubjectEmail}}
            </span>
          </div>
        </vs-td>
        <vs-td
          v-if="data[indextr].copySubjectTypeDigitalDoc.label"
          :data="data[indextr].copySubjectTypeDigitalDoc.label"
        >
          {{tr.copySubjectTypeDigitalDoc.label}}
          <small class="d-block">institución</small>
        </vs-td>
        <vs-td
          v-if="data[indextr].providence"
          :data="data[indextr].providence"
        >
          {{providencesMap[tr.providence]}}
          <span v-if="data[indextr].providenceExpiration">
            - {{tr.providenceExpiration | dateFormat}}
          </span>
          <small class="d-block">providencia</small>
        </vs-td>
        <vs-td
          v-if="tr.copySubjectType.value === 'sanitarias'"
          :data="data[indextr].subjectEmail"
        >
          <span>
            {{tr.subjectEmail}}
          </span>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
<script>
import ProvidencesMap from '@/febos/chile/dnt/mixins/ProvidencesMap';

export default {
  data() {
    return {
      isExternSubjects: [
        'personas', 'empresas', 'ministerios', 'personasJuridicas', 'organismoEstado'
      ],
      providencesMap: ProvidencesMap,
      copiesSelected: this.value || []
    };
  },
  watch: {
    copiesSelected() {
      this.$emit('input', this.copiesSelected);
    },
    value(newValue) {
      this.copiesSelected = newValue;
    }
  },
  props: {
    copies: {
      type: Array,
      required: true,
      default: () => []
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>
